import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import accpect from "../../assets/accepted-cards.png";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../components/common/UI/Inputs/InputControls/TextInput.jsx";
import { useStripe, useElements, CardElement, Elements, PaymentElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeElementsWrapper from "./StripeElementsWrapper.jsx";
import { purchaseCreditsActions, sendPhotosActions, store } from "../../_store";
import { showAlert } from "../../components/common/showAlert.js";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import translations from '../../config/TranslateFile.jsx'
import { CreateEventLogTextFileForInbox, EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue, removeStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";

// Initialize Stripe with your publishable key
const stripePromise = loadStripe("pk_test_GbfZ5fvw3FTcxSRIjc7W2lj4");

const PurchaseCreditsPayments = ({ stripeRandomOrderID, totalAmount, processingFee }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const elements = useElements();
  const currentLang = translations();
  const stripe = useStripe();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timeLeft, setTimeLeft] = useState(30 * 30); // 15 minutes in seconds
  //const timerRef = useRef(null);
  const startTimeRef = useRef(0);
  const myAccountDetails = useSelector((state) => state.myAccount.LoadPublicUserDetails);
  const UpdateStripeResponse = useSelector((state) => state.purchaseCredits.UpdateStripePaymentDetails);
  const paymentResponse = useSelector((state) => state.purchaseCredits.PaymentSubmitClick);
  const UserID = getStoredValue("userID");
  const InmateID = getStoredValue("StripeSelectInmateID");
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [holderName, setHolderName] = useState("");
  const [errorHolderName, setErrorHolderName] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const InmateDrpList = useSelector((x) => x.myContacts.LoadPublicMyContactsDisplay);

  const isSumbitted = useRef(false);


  useEffect(() => {
    showLoader();
  }, []);

  //Public user - Purchase Credit - Transaction Pending Email Not Triggered When User Navigates Away from Card Details Page Before Completion
  useEffect(() => {
    if (isSumbitted.current) return;
    const transactionPending = {
      name: holderName || `${myAccountDetails?.LastName} ${myAccountDetails?.FirstName}`,
      emailId: myAccountDetails?.Email || "",
      poTransactionID: "",
      poTransactionRandomID: stripeRandomOrderID?.stripeRandomOrderID || "",
      stripeResponse: "Transaction Pending",
      processingFee: processingFee ? String(processingFee) : "",
      amount: totalAmount?.totalAmount ? Number(totalAmount.totalAmount) : 0,
      transactionDate: new Date().toLocaleString("en-US", {
        timeZone: "America/New_York",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit",
        hour12: true,
      }).replace(",", ""),
    };
    setStoredValue("transactionPending", transactionPending);
  }, [holderName, stripeRandomOrderID, totalAmount, processingFee]);


  const handleSubmit = async (event) => {
    event.preventDefault();
    event.preventDefault();
    setLoading(true);
    isSumbitted.current = true; // Set the flag to indicate submission has occurred


    const infoMessage = 'Clicked Pay button for purchase credits';
    const redirectURL = "---";
    const Status = 'now loader is showing untill purchase complete';
    const Response = 'User Valid response is ' + "success" + ' Card Valid response is ' + "success";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);

    // Clear errors and proceed
    setErrorHolderName("");
    setError("");
    setLoading(true);
    dispatch(sendPhotosActions.CheckingMsgPhotoStatus({ addFormData: { UserID: UserID, InmateID: InmateID } })).then((response) => {
      const { Result, Notes } = response.payload;
      setLoading(false);
      switch (Result) {
        case -7:
          NotificationService({
            title: currentLang?.Message,
            message: currentLang?.ArchivedPagePopContent?.Connection_Blocked,
            type: "warning",
          });
          break;
        case -8:
          NotificationService({
            title: currentLang?.Message,
            message: currentLang?.ArchivedPagePopContent?.No_longer_connected,
            type: "warning",
          });
          break;
        case -6:
          NotificationService({
            title: currentLang?.Message,
            message: currentLang?.ArchivedPagePopContent?.Disabled_Contact,
            type: "warning",
          });
          break;
        case -4:
          NotificationService({
            title: currentLang?.Message,
            message: currentLang?.ArchivedPagePopContent?.Disabled_Facility,
            type: "warning",
          });
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          break;
        default:
          if (Result === 0) {
            StripePaymentEvent();
            setLoading(true);
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());

          }
          break;
      }

    })

  };

  const StripePaymentEvent = async () => {
    // Ensure Stripe and Elements are loaded
    if (!stripe || !elements) {

      setError("Payment processing is currently unavailable. Please refresh the page.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: "https://example.com/redirect-after-payment", // Optional
        },
        type: 'card',
        card: elements,
        redirect: "if_required", // Prevent automatic redirection
      });
      const { error, paymentIntent } = result;
      // Perform final validation before submission
      if (!holderName.trim()) {
        setErrorHolderName(currentLang?.PurchaseCreditsPopContent?.Name_Required);
        setLoading(false);
        const infoMessage = 'try to submit without filling all required Informaions';
        const redirectURL = "---";
        const Status = "---";
        const Response = '---';
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
        return;
      } else if (holderName.length < 3) {
        setErrorHolderName(currentLang?.PurchaseCreditsPopContent?.Name_Validation);
        setLoading(false);
        return;
      }
      if (error) {
        setLoading(false);
        // If payment succeeded despite the error
        if (error.payment_intent && error.payment_intent.status === "succeeded") {
          removeStoredValue("transactionPending");
          const infoMessage = "Payment completed";
          const redirectURL = "---";
          const Status = error.payment_intent.status;
          const Response = "---";
          CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
          setLoading(true);
          handleSuccessfulPayment(error.payment_intent);
        } else {
          const infoMessage = "payment failed.";
          const redirectURL = "---";
          const Status = error.payment_intent || error.payment_intent.status;
          const Response = "---";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status);
          setError(error.message || "Payment failed. Please try again.");
        }
      } else if (paymentIntent?.status === "succeeded") {
        removeStoredValue("transactionPending");
        // Payment succeeded
        const infoMessage = "Payment completed";
        const redirectURL = "---";
        const Status = paymentIntent?.status;
        const Response = "---";
        CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
        setLoading(true);
        handleSuccessfulPayment(paymentIntent);
      } else {
        setError("Unexpected issue occurred. Please try again.");
        const infoMessage = "payment failed.";
        const redirectURL = "---";
        const Status = paymentIntent?.status;
        const Response = "---";
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      }
    } catch (err) {
      setError("There was an issue processing your payment. Please try again.");
      setLoading(false);
    }
  }

  const handleEventlog = (paymentIntent) => {
    const infoMessage = 'Update Payment Details';
    const redirectURL = "---";
    const Status = 'Passing values for update PaymentIntent details in database ';
    const Response = 'name : ' + holderName + ', emailid:  ' + myAccountDetails.Email + ',POTransactionID:  '
      + paymentIntent.id + ',POTransactionRandomID:  ' + paymentIntent.description + ',Amount : ' + paymentIntent.amount / 100 +
      ', StripeResponse :' + paymentIntent.status;
    EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  }

  // Helper function to handle successful payments
  const handleSuccessfulPayment = (paymentIntent) => {
    setLoading(true);
    const transactionDate = new Date(paymentIntent.created * 1000).toLocaleString();

    const paymentData = {
      name: holderName == "" ? `${myAccountDetails.LastName} ${myAccountDetails.FirstName}` : holderName,
      emailId: myAccountDetails.Email,
      poTransactionID: paymentIntent.id,
      poTransactionRandomID: paymentIntent.description,
      stripeResponse: paymentIntent.status,
      processingFee: InmateDrpList?.length > 0 ? InmateDrpList[0]?.ProcessingFee : 1.5,
      amount: (paymentIntent.amount / 100).toFixed(2),
      transactionDate: transactionDate,

    };

    // Dispatch the payment details to Redux
    dispatch(purchaseCreditsActions.UpdateStripePaymentDetails(paymentData)).then((responses) => {
      if (responses.payload?.StripeResponse == 0 || responses.payload?.StripeResponse == -1) {
        dispatch(purchaseCreditsActions.SendMailForFailedTransaction({
          ...paymentData, stripeResponse: responses.payload?.StripeResponse == -1 ? "Transaction Failed" : "Transaction Pending",
          transactionDate: new Date().toLocaleString("en-US", {
            timeZone: "America/New_York",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          }).replace(",", ""),
        }));
      }
      if (responses.payload?.Result === 1) {
        const infoMessage = "Payment completed successfully.";
        const redirectURL = "---";
        const Status = responses.payload?.Result;
        const Response = JSON.stringify(responses.payload);
        CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
        const TransactionInvoiceInfo = {
          publicUserId: UserID,
          inmateID: InmateID,
          pOTransactionRandomID: paymentIntent.description

        }
        handleEventlog(paymentIntent);
        dispatch(purchaseCreditsActions.GetPurchaseOrderTransactionInvoiceInfo(TransactionInvoiceInfo))
          .then((response) => {
            setLoading(false);
            if (response.payload) {
              const PaymentDetails = response.payload;
              const infoMessage = "Page redirection";
              const redirectURL = "StripeElementsWrapper/public/PaymentReceipt";
              const Status = 'Payment details updated and page redirected';
              const Response = 'Page redirected to ' + PaymentDetails?.POTransactionRandomID;
              EventLog(dispatch, infoMessage, redirectURL, Response, Status);
              // Navigate to the success page
              navigate("public/PaymentReceipt", { state: { PaymentDetails } });
              storeCurrentRoute("public/PaymentReceipt");

            }
            else {
              const infoMessage = 'Payment update';
              const redirectURL = "---";
              const Status = 'Payment details updated failed';
              const Response = response.payload;
              EventLog(dispatch, infoMessage, redirectURL, Response, Status);
            }
          });
      }
      else {
        setLoading(false);
        const infoMessage = "payment failed.";
        const redirectURL = "---";
        const Status = responses.payload?.Result;
        const Response = JSON.stringify(responses.payload);
        CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
      }
    });
  };

  const handleTimeOver = async () => {
    const paymentFailedData = {
      puiConnectionID: 0,
      PaymentTransactionID: 0,
      PurchaseOrderTransactionID: 0,
      SucessURL: "",
      ManuallyUpdateType: "",
      POTransactionRandomID: stripeRandomOrderID?.stripeRandomOrderID,
      TransactionName: "",
      TransactionEmail: "",
      IsTransactionSuccess: -1,
      TransDate: "",
      isLoginValid: -1,
      PayType: "STRIPE",
      isManuallyUpdated: 0,
      IsManuallyUpdateTransaction: 0,
      CreatedBy: 0,
      IsPaymentIntentMethod: true,
    };
    dispatch(purchaseCreditsActions.PaymentTimeOut(paymentFailedData)).then((response) => {
      if (response.payload) {
        const mailpayload = {
          name: holderName || `${myAccountDetails.LastName} ${myAccountDetails.FirstName} `,
          emailId: myAccountDetails.Email,
          poTransactionID: '',
          poTransactionRandomID: stripeRandomOrderID?.stripeRandomOrderID,
          stripeResponse: "Transaction Failed",
          processingFee: processingFee ? processingFee : '',
          amount: totalAmount?.totalAmount ? totalAmount?.totalAmount : '',
          transactionDate: new Date().toLocaleString("en-US", {
            timeZone: "America/New_York",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          }).replace(",", ""),

        };
        dispatch(purchaseCreditsActions.SendMailForFailedTransaction(mailpayload));
        navigate("/public/PurchaseCredits");
        storeCurrentRoute("/public/PurchaseCredits");
      }
    });
  };

  const updateTimeLeft = () => {
    const currentTime = performance.now();
    const elapsed = Math.floor((currentTime - startTimeRef.current) / 1000);
    const remainingTime = Math.max(0, timeLeft - elapsed); // Make sure time doesn't go below 0

    setTimeLeft(remainingTime);

    // If time is up, handle the timeout
    if (remainingTime <= 0) {
      handleTimeOver();
    }
  };

  useEffect(() => {
    // Start the timer when the component is mounted
    startTimeRef.current = performance.now();
    const intervalId = setInterval(updateTimeLeft, 1000);

    return () => {
      // Cleanup the interval when the component unmounts
      clearInterval(intervalId);
    };
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const handleBackClick = () => {
    showLoader();
    removeStoredValue("transactionPending");
    const mailpayload = {
      name: holderName || `${myAccountDetails.FirstName} ${myAccountDetails.LastName}`,
      emailId: myAccountDetails.Email,
      poTransactionID: '',
      poTransactionRandomID: stripeRandomOrderID?.stripeRandomOrderID,
      stripeResponse: "Transaction Pending",
      processingFee: processingFee ? processingFee : '',
      amount: totalAmount?.totalAmount ? totalAmount?.totalAmount : '',
      transactionDate: new Date().toLocaleString(),

    };
    dispatch(purchaseCreditsActions.SendMailForFailedTransaction(mailpayload));
    hideLoader();
    // Redirect to /public/PurchaseCredits without going back to the previous page
    navigate('/public/Mycontacts', { replace: true });
    storeCurrentRoute("/public/Mycontacts");
  };
  const handlePaymentMsg = () => {
    setIsPaymentMsg(false);
  };
  const handleChangeHolderName = (e) => {
    const value = e.target.value;
    setHolderName(value);

    // Validation logic for real-time feedback
    if (!value.trim()) {
      setErrorHolderName(currentLang?.PurchaseCreditsPopContent?.Name_Required);
    } else if (value.length < 3) {
      setErrorHolderName(currentLang?.PurchaseCreditsPopContent?.Name_Validation);
    } else {
      setErrorHolderName(""); // Clear the error when valid
    }
  };

  return (
    <div>
      <ReactNotifications />
      {loader}
      <div className="d-flex justify-content-between align-items-center">
        <div className="header-title">
          <h5>
            {currentLang?.PurchaseCredits}
          </h5>
        </div>
        <button
          type="button"
          disabled={loading}
          onClick={handleBackClick}
          className="btn btn-danger me-1 mb-2"
        >
          <i class="fa-solid fa-arrow-left me-1"></i>
          {currentLang?.buttons?.Back}
        </button>

      </div>
      <div className="">

        <div className="row mb-5">
          <div className="col-md-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <h6 className="timer mb-3">
                  <p
                    style={{ textAlign: "center", fontSize: "18px", marginBottom: "-10px" }}
                  >
                    {currentLang?.PurchaseCreditsPage?.Expire}{" "}
                    <span style={{ fontSize: "23px", color: timeLeft <= 300 ? "#c8605e" : "black" }}>
                      {formatTime(timeLeft)}{" "}
                    </span>
                    {currentLang?.PurchaseCreditsPage?.Expire_Content}
                  </p>
                </h6>
                <div className="row">
                  <div className="col-lg-6">
                    <h3 className="heading mt-4">{currentLang?.PurchaseCreditsPopContent?.Billing_Address}</h3>
                    <div class="card shadow-sm border p-1 border-radius-all">
                      <div class="card-body" style={{ height: 'auto' }}>
                        <div className="form-group">
                          <TextInput
                            name="FullName"
                            id="FullName"
                            label={currentLang?.labels?.Full_Name}
                            value={`${myAccountDetails.LastName} ${myAccountDetails.FirstName} `}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <TextInput
                            name="Email"
                            id="Email"
                            label={currentLang?.labels?.Email}
                            value={myAccountDetails.Email}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <TextInput
                            name="Address"
                            id="Address"
                            label={currentLang?.labels?.Address}
                            value={
                              myAccountDetails.Address2
                                ? `${myAccountDetails.Address1 || ""}, ${myAccountDetails.Address2}`
                                : myAccountDetails.Address1
                            }
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <TextInput
                            name="City"
                            id="City"
                            label={currentLang?.labels?.City}
                            value={myAccountDetails.City}
                            disabled
                          />
                        </div>
                        <div className="row">
                          <div className="col-md-6">

                            <div className="form-group">
                              <TextInput
                                name="State"
                                id="State"
                                label={currentLang?.labels?.State}
                                value={myAccountDetails.StateName}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <TextInput
                                name="Zip"
                                id="Zip"
                                label={currentLang?.labels?.ZIP}
                                value={myAccountDetails.ZIP}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <h3 className="heading mt-4">{currentLang?.labels?.Checkout}</h3>
                    {/* <img src={accpect} className="w-auto mb-2" alt="Accepted Cards" /> */}
                    <Card
                      className=""
                      style={{
                        border: "1px solid #c7c3c3",
                        borderRadius: "10px",
                        minHeight: "87%", // Ensure the height matches the Billing Address
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between", // Align content for proper spacing
                      }}
                    >
                      <Card.Body className="p-4 bg-white border shadow-sm border-radius-all card-body" style={{ height: "auto" }}>
                        <div className="col-12 mb-2">
                          <label className="form-label w-100 fs-5 inmate-label">
                            {currentLang?.labels?.Name}
                          </label>
                          <input
                            name="Name"
                            id="Name"
                            placeholder={currentLang?.placeholders?.Enter_the_Name}
                            value={holderName}
                            onChange={handleChangeHolderName}
                            className={`form-control ${errorHolderName ? "is-invalid" : ""}`}
                            style={
                              errorHolderName
                                ? {
                                  borderColor: "#df1b41",
                                  boxShadow:
                                    "0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 1px #df1b41",
                                  color: "#df1b41",
                                  marginBottom: "0.25rem !important",
                                }
                                : { marginBottom: "0.25rem !important" }
                            }
                          />
                          {errorHolderName && (
                            <span
                              className="text-danger mb-2"
                              style={{
                                fontSize: "0.93rem",
                                color: "#df1b41",
                                marginTop: "0.25rem",
                              }}
                            >
                              {errorHolderName}
                            </span>
                          )}
                        </div>

                        <PaymentElement
                          options={{
                            defaultValues: {
                              billingDetails: { address: { country: "US" } },
                            },
                          }}
                          onReady={() => {
                            hideLoader();

                          }}
                        />
                        <Button
                          onClick={(e) => handleSubmit(e)}
                          variant="success font-size-15"
                          className="w-100 mt-4"
                          type={currentLang?.buttons?.Submit}
                          disabled={!stripe || loading}
                          loading={true}
                        >
                          {loading ? (
                            <>
                              <span className="me-2"> {currentLang?.Processing}</span>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>

                            </>
                          ) : (
                            <>
                              {currentLang?.Pay} ${totalAmount.totalAmount}
                            </>
                          )}
                          {/* {loading ? currentLang?.Processing : currentLang.Pay + " " + '  $' + totalAmount.totalAmount} */}

                        </Button>
                        <span className="text-danger d-flex justify-content-center mt-2">
                          {error}
                        </span>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={isPaymentMsg}
        onHide={handlePaymentMsg}
        onConfirm={handlePaymentMsg}
        title={currentLang?.Message}
        message={paymentMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </div>
  );

};

export default React.memo(PurchaseCreditsPayments);
